import React from 'react';
import styled from 'styled-components';

import links from '../../data/links';

import drive from '../../assets/icons/google_drive.svg';

import Box from './Box';

const Div = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 1600px;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 32px 0px 32px;
`;

const A = styled.a`
  opacity: 0.85;
  color: inherit;
  font-weight: bold;
  &:hover {
    opacity: 1;
  }
`;

const DriveDescription = (
  <span>
    You’ll be shocked to learn that we have a shared{' '}
    <A href={links.gamegosSharedGoogleDrive.link}>
      Google Drive folder
    </A>
    . You may find your answers there.
  </span>
);

function index() {
  return (
    <Div>
      <Box
        title="Still Need Help?"
        description={DriveDescription}
        image={drive}
      />
    </Div>
  );
}

export default index;
